import { useState, FormEvent, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

export default function RegisterPage() {
  const { user, initializing, register } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!initializing && user) navigate('/account');
  }, [user, initializing, navigate]);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    if (password.length < 6) {
      setError('كلمة المرور يجب أن تكون 6 أحرف على الأقل');
      return;
    }
    setLoading(true);
    try {
      await register(name, email, password, phone);
      navigate('/account');
    } catch (err: any) {
      setError(err.response?.data?.message || 'حدث خطأ في إنشاء الحساب');
    } finally {
      setLoading(false);
    }
  };

  if (initializing) {
    return (
      <main className="min-h-screen flex items-center justify-center bg-cream-50">
        <div className="text-center">
          <div className="animate-pulse w-12 h-12 bg-cream-200 rounded-full mx-auto mb-4" />
          <p className="text-charcoal-400 text-sm">جاري التحميل...</p>
        </div>
      </main>
    );
  }

  return (
    <main className="min-h-screen flex items-center justify-center bg-cream-50 py-12">
      <div className="w-full max-w-md mx-4">
        <div className="bg-white rounded-2xl border border-cream-300 shadow-sm p-8">
          <div className="text-center mb-8">
            <Link to="/" className="inline-block mb-4">
              <h2 className="text-2xl font-bold text-charcoal-900">سعاد الحاج</h2>
            </Link>
            <h1 className="text-xl font-bold text-charcoal-900 mb-1">إنشاء حساب جديد</h1>
            <p className="text-sm text-charcoal-500">انضمي إلينا واستمتعي بتجربة تسوق فاخرة</p>
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 text-sm rounded-lg p-3 mb-6 text-right">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-charcoal-700 mb-1.5 text-right">الاسم الكامل</label>
              <input
                type="text"
                value={name}
                onChange={e => setName(e.target.value)}
                required
                className="w-full border border-cream-300 rounded-xl px-4 py-3 text-sm text-charcoal-900 placeholder:text-charcoal-400 focus:outline-none focus:border-blush-200 bg-cream-50"
                placeholder="الاسم الكامل"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-charcoal-700 mb-1.5 text-right">البريد الإلكتروني</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                dir="ltr"
                className="w-full border border-cream-300 rounded-xl px-4 py-3 text-sm text-charcoal-900 placeholder:text-charcoal-400 focus:outline-none focus:border-blush-200 bg-cream-50"
                placeholder="email@example.com"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-charcoal-700 mb-1.5 text-right">رقم الهاتف</label>
              <input
                type="tel"
                value={phone}
                onChange={e => {
                  const val = e.target.value.replace(/\D/g, '').slice(0, 10);
                  setPhone(val);
                }}
                required
                dir="ltr"
                className="w-full border border-cream-300 rounded-xl px-4 py-3 text-sm text-charcoal-900 placeholder:text-charcoal-400 focus:outline-none focus:border-blush-200 bg-cream-50"
                placeholder="05XXXXXXXX"
                inputMode="numeric"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-charcoal-700 mb-1.5 text-right">كلمة المرور</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                dir="ltr"
                className="w-full border border-cream-300 rounded-xl px-4 py-3 text-sm text-charcoal-900 placeholder:text-charcoal-400 focus:outline-none focus:border-blush-200 bg-cream-50"
                placeholder="6 أحرف على الأقل"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 bg-charcoal-900 text-white rounded-xl text-sm font-medium hover:bg-charcoal-800 transition-colors disabled:opacity-50"
            >
              {loading ? 'جاري إنشاء الحساب...' : 'إنشاء حساب'}
            </button>
          </form>

          <p className="text-center text-sm text-charcoal-500 mt-6">
            لديك حساب؟{' '}
            <Link to="/login" className="text-blush-200 hover:text-blush-300 font-medium">
              تسجيل الدخول
            </Link>
          </p>
        </div>
      </div>
    </main>
  );
}
